import useEmblaCarousel from "embla-carousel-react";
import React from "react";
import "../../styles/components/embla.scss";
import { AnimatePresence, motion } from "framer-motion";
import Autoplay from "embla-carousel-autoplay";
import { GatsbyImage } from "gatsby-plugin-image";
import SingleSlide from "../blocks/SingleSlide";
import MdsSection from "../utilities/MdsSection";
import Anchor from "../elements/Anchor";
import MdsCol from "../utilities/MdsCol";
import { useDotButton } from "../elements/embla/EmblaCarouselButton";
import MotionSingle from "../utilities/Motion/MotionSingle";
import "../../styles/components/espa.scss";

const EmblaOptions = {
  loop: true,
  align: "start",
};

const AutoplayOptions = {
  playOnInit: true,
  delay: 3000,
  stopOnMouseEnter: true,
  stopOnInteraction: false,
};
const ProjectSlider = ({ slice }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(EmblaOptions, [
    Autoplay(AutoplayOptions),
  ]);
  const { selectedIndex, onDotButtonClick } = useDotButton(emblaApi);

  const { items: Slides } = slice;
  const {
    primary: { espa_image, pdf_link },
  } = slice;

  return (
    <MotionSingle offsetY={100} animateInstantly className="relative">
      <Anchor
        href={pdf_link?.url}
        target="_blank"
        className="anchor--prismic anchor--prismic-document espa-img"
        title="espa banner"
      >
        <GatsbyImage
          image={espa_image.gatsbyImageData}
          alt="espa banner image"
        />
      </Anchor>
      <MdsSection hasMaxWidth={false}>
        <div
          className="embla overflow-hidden flex flex-col sm:min-h-[500px] sm:h-dvh py-x4s mt-5"
          ref={emblaRef}
        >
          <div className="embla__container grid auto-cols-[100%] grid-flow-col h-full w-full grow">
            {Slides.length &&
              Slides.map((project) => {
                return (
                  <SingleSlide
                    key={project?.document?.data?.title}
                    slide={{ ...project }}
                  />
                );
              })}
          </div>
          <MotionSingle
            offsetY={0}
            offsetX={50}
            margin="-50px"
            className="h-fit mt-x4s"
          >
            <div className="slider-pagination w-full flex justify-end items-center h-fit">
              <div className="buttons-container bottom-0 left-0 flex xxl:gap-x-[16px] xs:gap-x-[10px]">
                {Slides.length &&
                  Slides.map((project, index) => {
                    return (
                      <button
                        type="button"
                        aria-label="slide-button"
                        key={`${project?.project?.document?.url}`}
                        onClick={() => onDotButtonClick(index)}
                        className={"flex-auto w-[calc(47px*var(--scale-ratio))] h-[calc(6px*var(--scale-ratio))] rounded-[calc(24px*var(--scale-ratio))] bg-white border border-black border-solid embla__dot".concat(
                          index === selectedIndex
                            ? " embla__dot--selected !bg-black"
                            : ""
                        )}
                      />
                    );
                  })}
              </div>
            </div>
          </MotionSingle>
          <MotionSingle
            offsetY={0}
            offsetX={50}
            margin="-50px"
            className=" h-fit mt-x3s"
          >
            <div className="project-slide__title flex justify-end">
              <div className="overflow-hidden w-full min-h-[calc(2*var(--h5-line-height))] relative">
                <AnimatePresence>
                  <motion.h2
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="text-end absolute top-0 right-0 h5"
                    key={Slides[selectedIndex]?.project?.document?.data?.title}
                  >
                    {Slides[selectedIndex]?.project?.document?.data?.title}{" "}
                    {Slides[selectedIndex]?.project?.document?.data?.region &&
                      `- ${Slides[selectedIndex]?.project?.document?.data?.region}`}
                  </motion.h2>
                </AnimatePresence>
              </div>
            </div>
          </MotionSingle>
        </div>
      </MdsSection>
    </MotionSingle>
  );
};

export default ProjectSlider;
